var _path, _path2, _path3;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgYourPackages = function SvgYourPackages(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7.1055V14.8441C17.5 15.0255 17.4016 15.1927 17.2429 15.2808L10.2429 19.1665C10.0919 19.2503 9.90818 19.2503 9.75718 19.1665L2.75719 15.2808C2.59847 15.1927 2.50002 15.0255 2.50002 14.8441L2.5 7.1055C2.5 6.92407 2.59845 6.7569 2.75718 6.66878L9.75718 2.78308C9.90818 2.69926 10.0919 2.69926 10.2429 2.78308L17.2429 6.66878C17.4015 6.7569 17.5 6.92407 17.5 7.1055Z",
    stroke: "#8A9FC7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.9375 7.05612L9.7543 10.8402C9.9053 10.9239 10.089 10.9239 10.24 10.8402L17.0805 7.04297",
    stroke: "#8A9FC7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.4689V10.9751",
    stroke: "#8A9FC7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYourPackages, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/YourPackages.f29eafdb.svg";
export { ForwardRef as ReactComponent };